var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshotFrame({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_631_4032)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 61,
    r: 60,
    fill: "#DD7451"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7255 97.336H52.7095V93.688H60.7415V92.712H52.6295V91.4H62.2935V94.968H54.1975V96.024H62.7255V97.336ZM58.9655 83.496V84.792H55.9895C56.0695 85.272 56.4055 85.544 56.9655 85.864C57.6375 86.248 58.2775 86.552 59.2375 86.968L58.5655 88.184C57.8135 87.848 57.1575 87.528 56.5175 87.192C55.7655 86.792 55.3495 86.52 55.2535 86.328H55.2375C55.1415 86.52 54.8375 86.776 53.9735 87.256C53.3015 87.624 52.6455 87.976 51.6215 88.44L50.9495 87.224C52.0055 86.728 52.7735 86.344 53.4615 85.928C54.0215 85.592 54.2935 85.224 54.3575 84.792H51.2855V83.496H54.3895V82.248H55.9735V83.496H58.9655ZM62.2935 90.856H60.7255V82.488H62.2935V85.832H64.3735V87.208H62.2935V90.856ZM59.8135 88.856L59.9415 90.12C57.3975 90.376 55.4775 90.488 50.5495 90.488V89.176C52.0695 89.176 53.3015 89.176 54.3575 89.16V87.736H55.9255V89.112C57.2855 89.064 58.4215 88.984 59.8135 88.856ZM68.44 94.84V94.2C68.44 92.648 70.136 91.384 72.968 91.384C75.8 91.384 77.496 92.648 77.496 94.2V94.84C77.496 96.392 75.8 97.656 72.968 97.656C70.136 97.656 68.44 96.392 68.44 94.84ZM72.904 86.28V87.096C72.904 88.52 71.752 90.328 69.24 90.328C66.728 90.328 65.576 88.52 65.576 87.096V86.28C65.576 84.856 66.728 83.048 69.24 83.048C71.752 83.048 72.904 84.856 72.904 86.28ZM77.432 91.192H75.88V89.016H73.56V87.656H75.88V85.688H73.56V84.328H75.88V82.488H77.432V91.192ZM75.944 94.744V94.296C75.944 93.512 74.792 92.68 72.968 92.68C71.144 92.68 69.992 93.512 69.992 94.296V94.744C69.992 95.528 71.144 96.36 72.968 96.36C74.792 96.36 75.944 95.528 75.944 94.744ZM71.384 87.016V86.36C71.384 85.416 70.712 84.424 69.24 84.424C67.768 84.424 67.096 85.416 67.096 86.36V87.016C67.096 87.96 67.768 88.952 69.24 88.952C70.712 88.952 71.384 87.96 71.384 87.016Z",
    fill: "#FEFAED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.42 32.8899H37V70.5599H91.42V32.8899Z",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.21 65.47C71.7984 65.47 77.95 59.3184 77.95 51.73C77.95 44.1416 71.7984 37.99 64.21 37.99C56.6216 37.99 50.47 44.1416 50.47 51.73C50.47 59.3184 56.6216 65.47 64.21 65.47Z",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.21 61.8901C69.8212 61.8901 74.37 57.3413 74.37 51.7301C74.37 46.1189 69.8212 41.5701 64.21 41.5701C58.5988 41.5701 54.05 46.1189 54.05 51.7301C54.05 57.3413 58.5988 61.8901 64.21 61.8901Z",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.47 40.93C85.2819 40.93 85.94 40.2718 85.94 39.46C85.94 38.6481 85.2819 37.99 84.47 37.99C83.6581 37.99 83 38.6481 83 39.46C83 40.2718 83.6581 40.93 84.47 40.93Z",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.47 28H41.49V32.89H50.47V28Z",
    stroke: "#FEFAED",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_631_4032",
    x: 0,
    y: 0,
    width: 128,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_631_4032"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_631_4032",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshotFrame);
export default __webpack_public_path__ + "static/media/screenshot_frame.d20799369c36db6eb239e3f1825496b1.svg";
export { ForwardRef as ReactComponent };